import { C } from "@/brand/tokens";
import { patterns5 } from "@/brand/content";

/**
 * PatternsSection5 — Dry Stone chamber.
 *
 * "The patterns we recognize" — a tightened restatement of who Faith 1st
 * serves. Four patterns as a vertical hairline list with brass gutter
 * numbers. Simpler than Concept 4's staggered indent; the emphasis
 * carries through calm typography and disciplined spacing.
 */
export function PatternsSection5() {
  return (
    <section
      data-testid="patterns"
      style={{
        background: C.surfaceLight,
        color: C.textOnLight,
      }}
    >
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8 lg:px-12 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-4 mb-7">
              <span
                aria-hidden="true"
                className="inline-block h-px w-14"
                style={{ background: C.accentMetal }}
              />
              <p
                className="font-inter text-[11px] uppercase font-semibold"
                style={{
                  color: C.accentMetal,
                  letterSpacing: "0.28em",
                }}
              >
                Is this for us?
              </p>
            </div>
            <h2
              className="font-cormorant"
              style={{
                color: C.textOnLight,
                fontSize: "clamp(2rem, 3.6vw, 3rem)",
                fontWeight: 400,
                lineHeight: 1.06,
                letterSpacing: "-0.012em",
              }}
            >
              Most organizations reach out
              <br />
              when a high-stakes people moment
              <br />
              can no longer be held alone.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 lg:pt-3">
            <p
              className="font-inter leading-[1.7] max-w-[44ch]"
              style={{ color: C.inkOnLight, fontSize: "1rem" }}
            >
              These four patterns account for most of our engagements. If
              one of them reads familiar, Faith 1st is likely built for the
              moment you are in.
            </p>
          </div>
        </div>

        <ol
          className="border-t"
          style={{ borderColor: C.borderSoft }}
          data-testid="patterns-list"
        >
          {patterns5.map((p, i) => (
            <li
              key={p.title}
              data-testid={`pattern-${i}`}
              className="grid grid-cols-12 gap-x-6 py-12"
              style={{ borderBottom: `1px solid ${C.borderSoft}` }}
            >
              <div className="col-span-2 lg:col-span-1 flex items-start">
                <span
                  className="font-cormorant tabular-nums"
                  style={{
                    color: C.accentMetal,
                    fontSize: "clamp(1.8rem, 2.4vw, 2.2rem)",
                    fontWeight: 400,
                    lineHeight: 1,
                  }}
                >
                  {p.n}
                </span>
              </div>
              <div className="col-span-10 lg:col-span-4">
                <p
                  className="font-inter text-[10.5px] uppercase font-semibold"
                  style={{
                    color: C.accentMetal,
                    letterSpacing: "0.26em",
                  }}
                >
                  {p.tag}
                </p>
              </div>
              <div className="col-span-12 lg:col-span-7">
                <h3
                  className="font-cormorant"
                  style={{
                    color: C.textOnLight,
                    fontSize: "clamp(1.35rem, 1.9vw, 1.65rem)",
                    fontWeight: 400,
                    lineHeight: 1.2,
                    letterSpacing: "-0.005em",
                  }}
                >
                  {p.title}
                </h3>
                <p
                  className="mt-4 font-inter leading-[1.7] max-w-[54ch]"
                  style={{ color: C.inkOnLight, fontSize: "0.98rem" }}
                >
                  {p.body}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
